import { PersonalInformation } from "../../components";

export default function Employee() {
  return <PersonalInformation />;
}
